<template>
    <div class="tools-tab tools-tab-user tools-mobile" :class="[$onduro.hasModule('availability') ? 'has-availability' : '']">
        <ul class="list" v-if=" ! loading">
            <template v-for="duty in activeDuties" v-if="filterUsersByDuty(duty).length">
                <li class="box-duty" :style="'background:'+duty.color" v-if="filterUsersByDuty(duty).length">
                    <span>{{ duty.name }}</span>
                </li>
                <li v-for="user in filterUsersByDuty(duty)" @click="select(user, duty)">
                    <span v-if="$onduro.hasModule('availability')" :class="getAvailabilityClasses(user)"></span>
                    <span>{{ user.name }}</span>
                    <icon name="add" v-if="multiple" />
                    <icon name="check" v-else />
                </li>
            </template>

            <li v-for="user in users" @click="select(user)" v-if=" ! activeDuties">
                <span v-if="$onduro.hasModule('availability')" :class="getAvailabilityClasses(user)"></span>
                <span>{{ user.name }}</span>
                <icon name="add" v-if="multiple" />
                <icon name="check" v-else />
            </li>
        </ul>
        <div class="empty" v-if=" ! loading && ! users.length">
            {{ $t('page.roster.tools.empty_users') }}
        </div>
    </div>
</template>

<script>
import events from '../../../events/events';
import shared from '../../../pages/planning/shared';

const availabilitySorting = ['available', 'limited', 'vacation', 'unavailable'];
const weekDays = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'];

export default
{
    name: 'User',

    props: ['date'],

    data() {
        return {
            shared: shared.state,
            multiple: false,
            loading: false,
            available: []
        }
    },

    computed:
    {
        users()
        {
            return this.sort(this.map(this.shared.users));
        },

        // only show duties for this user
        duties()
        {
            return _.sortBy(this.shared.duties, ['name']);
        },

        activeDuties()
        {
            return _.filter(this.duties, {trashed: false});
        },
    },

    created()
    {
        this.fetchAvailable();
    },

    methods:
    {
        fetchAvailable()
        {
            this.loading = true;
            this.$http.get('/api/locations/' + this.shared.location + '/users/' + this.date)
                .then(response =>
                {
                    this.loading = false;
                    this.available = response.data;
                });
        },

        filter(users)
        {
            return _.filter(users, user =>
            {
                // user is not in available user list
                if (this.available.indexOf(user.id) == -1) return false;

                return true;
            });
        },

        filterUsersByDuty(duty)
        {
            // legacy users are users that are visible in the roster (because they have been scheduled someday)
            // but are not currently assigned to the location anymore
            return _.filter(this.users, function (user)
            {
                if (user.legacy) return false;

                return user.duties.indexOf(duty.id) !== -1;
            });
        },

        map(users)
        {
            if ( ! this.$onduro.hasModule('availability')) return users;

            return _.map(users, user =>
            {
                user.availability = this.getAvailability(user);

                return user;
            });
        },

        sort(users)
        {
            return _.sortBy(users, [user =>
            {
                if ( ! this.$onduro.hasModule('availability')) return 0;
                return user.availability.sorting;
            }, 'name']);
        },

        select(user, duty)
        {
            let item =
            {
                assigned: false,
                duty: (duty) ? duty.id : null,
                shift: null,
                user: user.id,
            };

            events.$emit('items.add', item, this.date);
        },

        getAvailability(user)
        {
            let availabilities = this.shared.availability.users[user.id];

            if (availabilities && availabilities[this.date])
            {
                let availability = _.clone(availabilities[this.date]);

                if (availability.constraints) availability.status = 'limited';

                availability.sorting = availabilitySorting.indexOf(availability.type);

                return availability;
            }
            else
            {
                let defaultType = this.shared.availability.defaults[user.id];

                return {
                    constraints: null,
                    status: null,
                    type: defaultType,
                    sorting: availabilitySorting.indexOf(defaultType)
                }
            }
        },

        getAvailabilityClasses(user)
        {
            let availability = user.availability.defaultAvailabilities,
                day = moment(this.date).isoWeekday() - 1;

            availability = availability ? availability[weekDays[day]].value ? 'available': 'unavailable' : user.availability.type ;

            return [
                'availability',
                'is-' + availability,
                'is-' + user.availability.status
            ];
        },
    },
}
</script>



// WEBPACK FOOTER //
// NewUser.vue?5be64394